import { createEvent } from 'effector'

export {
  createMediaQueryStore,
  history,
  holdup,
  lookbehind,
  postpone,
  live,
  createListen,
} from './belt'
export {
  genNestedPagesLogic,
  genPagesLogic,
  genPagesLogicNew,
} from './genPagesLogic'
export { createMachina } from './machina'
export { getNextPage } from './pagination-by-cursor'
export { selectBestTab } from './tabs'

// event to do nothing, can be used anywhere to swallow a signal, hence accepts `any`
export const noop = createEvent<any | void>()
